import { z } from "zod";

export const estabelecimentoSchema = z.object({
  nome: z.string().min(1, "Nome é obrigatório"),
  endereco: z.string().optional(),
  telefone: z.string().optional(),
  email: z.string().email("Email inválido").optional().or(z.literal("")),
  responsavel: z.string().optional(),
  cnpj: z.string().optional(),
  ativo: z.boolean().default(true),
  observacoes: z.string().optional(),
});

export type EstabelecimentoFormData = z.infer<typeof estabelecimentoSchema>;
